// extracted by extract-css-chunks-webpack-plugin
module.exports = {"goodsContainer":"goodsContainer-3mDO3w_s"};